import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth rides on the httpOnly "obligo_session" cookie; nothing sensitive is kept in JS storage.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(undefined, (err) => {
  const d = err?.response?.data?.detail;
  if (err?.response?.status === 401 && typeof d === "string" && d.startsWith("Office hours") && window.location.pathname !== "/login") {
    sessionStorage.setItem("obligo_logout_reason", `${d} Your running timer was stopped at the end time.`);
    window.location.assign("/login");
  }
  return Promise.reject(err);
});

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}
